import { RdGroupingTicketOrCollection } from '@neo.tax/shared';

import { StyledTicketGroup, StyledTicketGroupList, StyledTooltip } from './rd-projects-layout.styled';

export type RdProjectTicketSystemProjectCellProps = {
  groupings: RdGroupingTicketOrCollection[];
};

export const RdProjectTicketSystemProjectCell = ({
  groupings,
}: RdProjectTicketSystemProjectCellProps): React.ReactElement => {
  const names = groupings.map((g) => g.name).join(', ');
  const tooltipContent = (
    <StyledTicketGroupList>
      {groupings.map((grouping) => (
        <li key={grouping.id}>{grouping.name}</li>
      ))}
    </StyledTicketGroupList>
  );

  return (
    <StyledTooltip
      text={tooltipContent}
      options={{
        placement: 'bottom',
        showArrow: true,
      }}
    >
      <StyledTicketGroup as="p" color="inherit" textOverflow="truncate" fontSize="inherit">
        {names}
      </StyledTicketGroup>
    </StyledTooltip>
  );
};
